<template>
  <transition name="forward">
    <div v-if="boxshow" class="orderedBg bg-yellow">
      <div class="top">
        <bg-yun>
          <div class="padding-10 flex-layout font-0-8">
            <div class="flex-1" v-if="tableNum">桌号：<span class="color-red">{{tableNum}}</span></div>
            <div class="flex-1 text-center">已点：<span class="color-red">{{billHead.count}}</span>道</div>
            <div class="flex-1 text-center">共计：<span class="color-red">{{billHead.amount}}元</span></div>
          </div>
        </bg-yun>
      </div>
      <div class="content">
        <scroller>
          <div class="cue_card padding-10 font-0-9">
            提示：如果需要针对某一道菜添加制作要求，请点击该菜品的名称，您输入的要求将打印在厨房单据上。
          </div>
          <!--非套餐-->
          <div class="magin-t-6" v-for="type in billDtl">
            <div class="typename text-center">
              <!--大类名称-->
              <div class="padding-5-10 font-0-9 bg-yellow">{{type.name}} {{type.menuItem.length}}道</div>
            </div>
            <div  v-for="(order,orderIndex) in type.menuItem">
              <bg-yun>
                <!--菜品信息-->
                <div class="padding-5 flex-layout bg-white">
                  <div class="flex-4 flex-layout padding-5">

                    <div class="flex-3" @click.stop="clickOrder(order)">
                      <div class="font-0-9 text-nowrap">{{order.name}}</div>
                      <div class="font-0-8 text-nowrap">
                        <span class="color-red">{{order.price}}</span>元<span v-if="order.standard">/{{order.standard}}</span>
                        <span class="color-yellow" v-if="order.memo">[{{order.memo}}]</span>
                      </div>
                    </div>
                  </div>
                  <!--数量加减-->
                  <div class="flex-2 flex-layout">
                    <div class="flex-1" @click.stop="clickSub(type,order,orderIndex)">
                      <img src="../../assets/image/subIcon.svg" width="30" alt="" style="vertical-align: middle;pointer-events: none;">
                    </div>
                    <div class="flex-1">
                      <div class="order-num font-0-6">{{order.num}}</div>
                    </div>
                    <div class="flex-1" @click.stop="clickAdd(type,order)">
                      <img src="../../assets/image/addIcon.svg" width="30" alt="" style="vertical-align: middle;pointer-events: none;">
                    </div>
                  </div>
                </div>
                <!--配菜-->
                <div class="bg-white padding-10 flex-layout font-0-7 border-t" v-for="item in order.menuItem">
                  <div class="flex-1 text-left padding-L-25">{{item.num}} ×{{item.standard}}</div>
                  <div class="flex-4 padding-L-5">{{item.name}}  <span class="color-yellow" v-if="item.memo">[{{item.memo}}]</span></div>
                  <div class="flex-2 color-yellow" style="text-align: right" v-if="type.isGroup == 0">{{item.price}}元 /{{item.standard}}</div>
                </div>
              </bg-yun>
            </div>
          </div>

          <!--套餐-->

          <div class="magin-t-6" v-if="suitBillDtl.length>0">
            <div class="typename text-center">
              <!--大类名称-->
              <div class="padding-5-10 font-0-9 bg-yellow">套餐 {{suitBillDtl.length}}道</div>
            </div>
            <div  v-for="(order,index) in suitBillDtl">
              <bg-yun>
                <!--菜品信息-->
                <div class="padding-5 flex-layout bg-white">
                  <div class="flex-4 flex-layout padding-5">

                    <div class="flex-3" @click.stop="clickOrder(order)">
                      <div class="font-0-9 text-nowrap">{{order.name}}</div>
                      <div class="font-0-8 text-nowrap">
                        <span class="color-red">{{order.price}}</span>元<span v-if="order.standard">/{{order.standard}}</span>
                        <span class="color-yellow" v-if="order.memo">[{{order.memo}}]</span>
                      </div>
                    </div>
                  </div>
                  <!--数量加减-->
                  <div class="flex-2 flex-layout">
                    <div class="flex-1" @click.stop="clickSuitSub(suitBillDtl,order,index)">
                      <img src="../../assets/image/subIcon.svg" width="30" alt="" style="vertical-align: middle;pointer-events: none;">
                    </div>
                    <div class="flex-1">
                      <div class="order-num font-0-6">{{order.num * 1}}</div>
                    </div>
                    <div class="flex-1" @click.stop="clickSuitAdd(order)">
                      <img src="../../assets/image/addIcon.svg" width="30" alt="" style="vertical-align: middle;pointer-events: none;">
                    </div>
                  </div>
                </div>
                <!--配菜-->
                <div class="bg-white padding-10 flex-layout font-0-7 border-t" v-for="item in order.menuItem">
                  <div class="flex-1 text-left padding-L-25">{{item.num * 1}} ×{{item.standard}}</div>
                  <div class="flex-4 padding-L-5">{{item.name}}  <span class="color-yellow" v-if="item.memo">[{{item.memo}}]</span></div>
                </div>
              </bg-yun>
            </div>
          </div>
        </scroller>
      </div>
      <div class="footer2 color-white font-0-8 text-center flex-row">
        <div class="footer-item bg-blue" @click.stop="clickAddOrder()">
          <img class="left" src="../../assets/image/arrow-left.png" width="20" >加菜
        </div>
        <div class="flex1"></div>
        <div class="footer-item bg-gray-yellow" @click.stop="clickClear()">清除</div>
        <div class="flex1"></div>
        <div class="footer-item bg-footer-yellow" @click.stop="billOrder()">去下单<img class="right" src="../../assets/image/arrow-right.png" width="20"
               style=""></div>
      </div>
      <addmemo ref="addmemo"></addmemo>

      <mustdialog :show="mustdialog" @onCancel="onCancel" :list="bidianMenu" forceadd="1"></mustdialog>

    </div>
  </transition>
</template>
<script>
  import bgyun from '../bg-yun/bgyun.vue';
  import ServiceHttp from '../../service/ServiceHttp'
  import ServiceUtil from '../../service/ServiceUtils'
  import ServiceDialog from '../../service/ServiceDialog'
  // import alertPeople from './tpl/alertPeopleNum.vue'
  import addmemo from '../addMemo/addmemo.vue';
  import DiaTable from '../isTakeOut/index'
  import Mustdialog from "./mustdialog";
  export default {
    name: 'ordered',
    data () {
      return {
        uid:"",
        tableNum:'',
        billHead:{},
        billDtl:[],      //非套餐数据
        suitBillDtl:[],  //套餐数据
        interverName:'',
        bidianMenu:[],
        mustdialog:false
      }
    },

    props:{
      boxshow:false,
      backOrder:{
        type : Function,
        default : null
      }
    },

    components:{
      Mustdialog,
      'bg-yun':bgyun,
      'addmemo':addmemo
    },
    methods:{
      //开关
      togglebox:function(){
        this.boxshow = !this.boxshow;
      },
      //点击加菜
      clickAddOrder(){
        if(this.backOrder){this.backOrder();}
      },
      /**
       * 点击清除菜品
       */
      clickClear(){
        ServiceDialog.confirm('温馨提示','您确定清除数据？',()=>{
          ServiceHttp.deleteBill((res)=>{
              ServiceUtil.suitBillData.length =0;
              ServiceUtil.noSuitBillData.length = 0;
              ServiceUtil.calculateTypeNum();
              ServiceUtil.calculateCarTotal();
          });
        })
      },

      /**
       * 去下单
       * */
      billOrder(isfromoncancel){
        if (this.billHead.qty <= 0) {
          ServiceDialog.showAlert("温馨提示", "您尚未点菜，请您先点菜！");
          return;
        }
        if(!isfromoncancel){
          let _orderedMap = {};
          ServiceUtil.noSuitBillData.forEach(type => {
            type.menuItem.forEach(item => {
              _orderedMap[item.code] = true;
            })
          });
          //没有必点项
          if (ServiceUtil.bidianMenu.length > 0) {
            let codes = [];
            ServiceUtil.bidianMenu.forEach(item=>{
              if (!_orderedMap[item.code]) {
                codes.push(item.code);
              }
            });

            if(codes.length>0) {
              this.mustdialog = true;
              let bidianMenu = ServiceUtil.bidianMenu;
              let arr = [];
              for(let item of bidianMenu) {
                if(codes.indexOf(item.code)!=-1){
                  arr.push({
                    code: item.code,
                    desc: item.desc,
                    drink: item.drink,
                    iconPath: item.iconPath,
                    id: item.id,
                    indexpicshow: item.indexpicshow,
                    memberNo: item.memberNo,
                    memberprice: item.memberprice,
                    memoflag: item.memoflag,
                    minOrderNum: item.minOrderNum,
                    name: item.name,
                    picMode: item.picMode,
                    picPath: item.picPath,
                    price: item.price,
                    remark: item.remark,
                    sndname: item.sndname,
                    sortNum: item.sortNum,
                    standard: item.standard,
                    standards: item.standards,
                    state: item.state,
                    menuItem: [],
                  })
                }
              }
              this.bidianMenu = arr;
              return;
            }
          }
        }


        if((ServiceUtil.config.orderType===2 || ServiceUtil.config.orderType === '2') && ServiceUtil.stores.length==0){
          ServiceHttp.getStoreData((res)=>{
            if(res){
              res.storefront.forEach((itemStore)=>{
                if(itemStore.sellerid==ServiceUtil.config.sellerId && itemStore.id==ServiceUtil.config.storeId){
                  ServiceUtil.config.sendAmount = itemStore.sendAmount/100;
                  ServiceUtil.config.distributionCharge = itemStore.distributionCharge/100;
                }
              });
            }
            this.sendBill();
          })
        }else {
          this.sendBill();
        }
      },

      //必点项弹框回调
      onCancel(data){
        if(data){
          let flag = false;
          let yddata = [];//已点数据
          for(let item of this.billDtl){
            if(item.code=='bidian'){
              for(let item2 of item.menuItem){
                yddata.push(item2.code)
              }
              //判断已选的是否在已点的里，如果在就替换，不在就添加
              for(let item3 of data){
                if(yddata.indexOf(item3.code) == -1) { //不在
                  item.menuItem.push(item3)
                }
              }
              flag = true;
              break;
            }
          }
          if(!flag){
            let menu = {code: "bidian", ename: "", isGroup: 0, menuItem: data, name: "必点项"}
            this.billDtl.push(menu);
          }
          ServiceUtil.noSuitBillData = this.billDtl;
          ServiceUtil.calculateCarTotal();
          ServiceUtil.calculateTypeNum();
        }else{
          this.billOrder(true);
        }
        this.mustdialog = false;
      },

      sendBill(){
        if ((ServiceUtil.config.orderType===2 || ServiceUtil.config.orderType === '2') && this.billHead.amount < ServiceUtil.config.sendAmount) {
          let text = "门店外卖起送金额为{0}元<br>您消费金额未满起送金额，请您继续点菜！".format(ServiceUtil.config.sendAmount);
          ServiceDialog.showAlert("温馨提示", text);
          return;
        }
        if (ServiceUtil.config.orderType === 0 || ServiceUtil.config.orderType === '0') { //堂食
          this.inputTableNo();
        } else if (ServiceUtil.config.orderType === 1 || ServiceUtil.config.orderType === '1') { //自提
          this.inputTableNo();
        } else if (ServiceUtil.config.orderType === 2 || ServiceUtil.config.orderType === '2') { //外卖
          this.sendBillToServer();
        }
      },

      inputTableNo(){
        //有餐桌号,无需在填写餐桌号
        if (ServiceUtil.config.isTakeTable) {
          if (ServiceUtil.config.orderType === 0 || ServiceUtil.config.orderType === '0') { //堂食
            ServiceHttp.checkTable(()=> {
              this.sendBillToServer();
            });
          } else if (ServiceUtil.config.orderType === 1 || ServiceUtil.config.orderType === '1') { //外带自提
            this.sendBillToServer();
          }
          return;
        }else {//没有餐桌号时，如果是外带自提，不用输入餐桌号
          if (ServiceUtil.config.orderType === 1 || ServiceUtil.config.orderType === '1') { //外带自提
              this.sendBillToServer();
              return;
          }
          DiaTable.open(ServiceUtil.config.tableNo,(is,res)=>{
            if(is){
              ServiceUtil.config.orderType = res.id;
              if (ServiceUtil.config.orderType === 0 || ServiceUtil.config.orderType === '0') { //堂食
                ServiceUtil.config.tableNo = res.tableNo ;
                ServiceHttp.checkTable(()=> {
                  this.sendBillToServer();
                });
              } else if (ServiceUtil.config.orderType === 1 || ServiceUtil.config.orderType === '1') { //外带自提
                this.sendBillToServer();
              }
            }
          })
        }
      },


      sendBillToServer(){
        let billHead = {
            orderType:ServiceUtil.config.orderType,
            qty:ServiceUtil.orderedTotal.qty,
            amount:ServiceUtil.orderedTotal.amount,
            tableNo:ServiceUtil.config.tableNo
        };
        let bd = [];
        bd.append(ServiceUtil.noSuitBillData);
        if (ServiceUtil.suitBillData.length > 0) {
          bd.push({
            code: '999999',
            name: '套餐',
            isGroup: "1",
            menuItem: ServiceUtil.suitBillData
          });
        }
        console.log('提交的数据：：',bd);
        //发现有code是空的直接清除掉
        for(let i in bd){
          let item = bd[i];
          if(item.code == 'bidian'){
            for(let j=0;j<item.menuItem.length;j++){
              let item2 = item.menuItem[j];
              if(!item2.code){
                item.menuItem.splice(j,1);
                j--;
              }
            }
          }
        }
        ServiceHttp.sendBill(billHead,bd, function(resData) {
           window.location.href = resData.resultUrl;
        });
      },
      /**
       * 点击减号
       * */
      clickSub(type,order,index){
        console.log(order);
        var doDelete = function(){
          order.num--;
          if(order.num < ServiceUtil.menuItemDataMap[order.code].minOrderNum || 0){
            order.num = 0;
          }
          order.num = Math.max(0,order.num);
          if(order.num == 0){
            type.menuItem.splice(index,1);
          }
          ServiceUtil.calculateCarTotal();
          ServiceUtil.calculateTypeNum();
        };
        var _str ="您确定删除该菜品吗？";

        if((ServiceUtil.menuItemDataMap[order.code].minOrderNum || 1)>1){
          _str = "该菜品最小点菜数量为{0}份，您确定删除该菜品吗？".format(ServiceUtil.menuItemDataMap[order.code].minOrderNum );
        }

        if(order.num <= (ServiceUtil.menuItemDataMap[order.code].minOrderNum || 1)){
          ServiceDialog.confirm('温馨提示',_str,()=>{
            doDelete();
          });
        }else {
          doDelete();
        }



      },
      /**
       * 点击加号
       * @param type
       * @param order
       */
      clickAdd(type,order){
        order.num++;
        order.num = Math.max(0,order.num);
        ServiceUtil.calculateCarTotal();
        ServiceUtil.calculateTypeNum();
      },
      /**
       * 点击套餐减号
       * */
      clickSuitSub(suit,order,index){
        var doDelete = function(){
          order.num--;
          if(order.num < (ServiceUtil.menuItemDataMap[order.code].minOrderNum || 0)){
            order.num = 0;
          }
          order.num = Math.max(0,order.num);
          if(order.num == 0){
            suit.splice(index,1);
          }
          ServiceUtil.calculateCarTotal();
          ServiceUtil.calculateTypeNum();
        };

        var _str ="您确定删除该菜品吗？";

        if((ServiceUtil.menuItemDataMap[order.code].minOrderNum || 1)>1){
          _str = "该菜品最小点菜数量为{0}份，您确定删除该菜品吗？".format(ServiceUtil.menuItemDataMap[order.code].minOrderNum );
        }

        if(order.num <= (ServiceUtil.menuItemDataMap[order.code].minOrderNum || 1)){
          ServiceDialog.confirm('温馨提示',_str,()=>{
            doDelete();
          });
        }else {
          doDelete();
        }

      },
      /**
       * 点击套餐加号
       * @param type
       * @param order
       */
      clickSuitAdd(order){
        order.num++;
        order.num = Math.max(0,order.num);
        ServiceUtil.calculateCarTotal();
        ServiceUtil.calculateTypeNum();
      },
      //点击菜品名称 添加备注
      clickOrder(order){
        this.$refs.addmemo.togglebox(order,()=>{})
      }
    },

    mounted(){
      this.tableNum=ServiceUtil.config.tableNum;
      this.billHead = ServiceUtil.orderedTotal;
      this.billDtl  = ServiceUtil.noSuitBillData;
      this.suitBillDtl = ServiceUtil.suitBillData;

    },

  }
</script>
<style scoped lang="scss">
  @import "../../assets/css/style";
  .content{position: absolute;top:55px;bottom:50px;left: 0;right: 0;}
  .footer2{
    position: fixed;padding: 4px 6px;right: 0;left: 0;bottom: 0;background-color: #000;}
  .footer-item{
    height: 42px;width: 23%;border-radius: 3px;line-height: 42px;
    .left{
      margin-bottom: 2px;
      vertical-align: middle;
    }
    .right{
      margin-bottom: 3px;
      vertical-align: middle;
    }
  }
  .bg-footer-yellow{background-color: #FF6D00}
  .typename{background-color: #F6F3E8;}
  .order-num{width: 25px;height: 25px;text-align: center;line-height: 25px;border: 1px solid rgba(140, 64, 22, 0.29);border-radius: 3px;}
  .border-t{border-top: 1px dashed #ddd}
  .top{position: absolute;top:0;left: 0;right: 0;height: 55px;z-index: 15;}
  .orderedBg{position: fixed;top: 0;right: 0;left: 0;bottom: 0;z-index: 99;}
  .cue_card{border-bottom: 0.5px solid rgba(180, 142, 90, 0.37);}
  .bg-yellow{background: #F7F3E7;}
  .padding-10{padding: 10px;}
  .flex-layout{ display: flex;  align-items: center;}
  .font-0-8{font-size: 0.8em;}
  .flex-1{flex:1;overflow:hidden;width: 0}
  .text-center{text-align: center}
  .text-right{text-align: right}
  .color-red{color: red}
  .font-0-9{font-size: 0.9em;}
  .magin-t-6{
    margin-top: 6px;
  }
  .padding-5-10{
    padding: 5px 0 10px 0;
  }
  .padding-5{padding: 5px;}
  .bg-white{background:#ffffff}
  .flex-4{flex:4;overflow:hidden;width: 0}
  .flex-3{flex:3;overflow:hidden;width: 0}
  .text-nowrap{overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
  .color-yellow{color:#FF6D00}
  .font-0-7{font-size: 0.7em;}
  .text-left{text-align: left;}
  .padding-L-5{
    padding-left: 5px;
  }
  .bg-gray-yellow{background:#CEB66B}
  .bg-blue{background:#00ABF8}

</style>



// WEBPACK FOOTER //
// src/components/ordered/ordered.vue